import store from "@/store";
import { amountFormatter, formatNumberWithComma } from "./order";
import i18n from "@/i18n";
export const cancelFormatter = (row) => {
  // <button style="padding-top:2px; color:#ff7519; background-color:transparent" onclick="dispatchChase(${row.ordid})">Chase</button>
  return `
  <button style="background-color:transparent" onclick="dispatchCancel('${row.ordid}')">🗑️</button>
`;
};
export const statusFormatter = (row) => {
  let status;
  let color;
  switch(row.status){
    case '1' : status = i18n.translate('trading.table.filled'); color="#2ea03f";
    break;
    case '3' : status = i18n.translate('trading.table.cancel'); color="#e6230d";
    break;
    case '4' : status = i18n.translate('trading.table.expired'); color="#999";
    break;
    default : status = "-"; color="#999";
    break;
  }
  return `<p style='color:${color}'>${status}</p>`;
};
export const symbolFormatter = (row) => {
  const bgColor = '#222222';
  return `${row.symbol}USDT <span style="background-color:${bgColor}; padding: 0 5px;">Perp</span>`;
};
export const typeFormatter = (row) => {
    let type;
    switch(row.type){
      case 'limit' : type =i18n.translate('trading.table.limit');
      break;
      case 'market' : type =i18n.translate('trading.table.market');
      break;
      case 'tp' : type =i18n.translate('trading.table.tpm');
      break;
      case 'sl' : type =i18n.translate('trading.table.sm');
      break;
    }
    return type;
};
export const sideFormatter = (row) => {
    const type = row.side === 'buy' ? i18n.translate('trading.table.buy') : i18n.translate('trading.table.sell');
    return `<span style="color:${row.side === 'buy' ? '#2ea03f' : '#e6230d'}">${type}</span>`;
}; 

export const averageFormatter = (price,type) => {
  if(type === 'tp' || type === 'sl'){
      return '-';
  }else{
      return price;
  }
}
export const executedFormatter = (v,symbol,type) =>{
  if(type === 'tp' || type === 'sl'){
      return 0;
  }else{
      return amountFormatter(v,symbol);
  }
}

export const triggerFomatter = (row) => {
  if(row.type === 'tp'){
    return `${i18n.translate('trading.table.entryPrice')} >= ${formatNumberWithComma(row.price)}`;
  }else if(row.type === 'sl'){
    return `${i18n.translate('trading.table.entryPrice')} <= ${formatNumberWithComma(row.price)}`;
  }else{
    return "-";
  }
}

export const marginTypeFormatter = (type) => {
  return type === 'cross' ? 'Cross' : 'Isolated';
}